// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OZDUUnd1xb {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.OZDUUnd1xb h4 {
  line-height: 3em;
}
.OZDUUnd1xb .cF0IRXE2mQ {
  float: left;
  width: 100%;
}
.OZDUUnd1xb .rqt1YAHlp1 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.OZDUUnd1xb .rqt1YAHlp1:hover {
  cursor: pointer;
}
.OZDUUnd1xb .rqt1YAHlp1:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.JPw2YILbBl .Va4VmIPyAD:focus {
  outline: none;
}
.JPw2YILbBl .Va4VmIPyAD.qTuaVhny4E.Xjh0AP_pvl {
  background: #375A88;
}
.JPw2YILbBl .Va4VmIPyAD.qTuaVhny4E.Xjh0AP_pvl span {
  color: #fff;
}
.JPw2YILbBl .Xjh0AP_pvl {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.JPw2YILbBl .Xjh0AP_pvl:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.JPw2YILbBl input {
  height: 38px;
  min-width: 220px;
}
.rqt1YAHlp1.CXgZub1GWF {
  background: #410102;
}
.rqt1YAHlp1.OKRcGhQvyv {
  background: #911318;
}
.rqt1YAHlp1.wARjpy_S_o {
  background: #D8293B;
}
.rqt1YAHlp1.f3F79NQbLN {
  background: #F2373C;
}
.rqt1YAHlp1.AOuJpArHxY {
  background: #FC4448;
}
.rqt1YAHlp1.sWB9hqH77f {
  background: #ED535E;
}
.rqt1YAHlp1.Mf6010P8sD {
  background: #E34926;
}
.rqt1YAHlp1.xKHNHLhB98 {
  background: #FC562B;
}
.rqt1YAHlp1.q7I9W1C_uE {
  background: #FC6722;
}
.rqt1YAHlp1.zTHhktdlXz {
  background: #FD7F24;
}
.rqt1YAHlp1.tA4GaxqD99 {
  background: #FD8D26;
}
.rqt1YAHlp1.dmeWD56VN7 {
  background: #EC9C3E;
}
.rqt1YAHlp1.KpS6oRWnTR {
  background: #0e673a;
}
.rqt1YAHlp1.Rx6tSrw5rL {
  background: #208740;
}
.rqt1YAHlp1.ZCx_1_lBFe {
  background: #239718;
}
.rqt1YAHlp1.Rwj4hinyra {
  background: #55A84D;
}
.rqt1YAHlp1.qxSLb6vjir {
  background: #4BBE5A;
}
.rqt1YAHlp1.xic2UGmpsT {
  background: #0CCA6A;
}
.rqt1YAHlp1.JU2DAx58Pm {
  background: #0A3C64;
}
.rqt1YAHlp1.Fz5wdJcE1Y {
  background: #0d487a;
}
.rqt1YAHlp1.uLpxLAwJeN {
  background: #10538d;
}
.rqt1YAHlp1.ILcd8mw3Hq {
  background: #115A99;
}
.rqt1YAHlp1.DGe1vEk_yl {
  background: #3387E2;
}
.rqt1YAHlp1.xGpJpcCUB9 {
  background: #1BA9CF;
}
.rqt1YAHlp1.vdCwVFaR2D {
  background: #d27c02;
}
.rqt1YAHlp1.FE4CfOnaIS {
  background: #fb9402;
}
.rqt1YAHlp1.BCVV32fIa6 {
  background: #FD9B30;
}
.rqt1YAHlp1.gXwbjJzDag {
  background: #FDBE2D;
}
.rqt1YAHlp1.rT0SBLFVZn {
  background: #FED831;
}
.rqt1YAHlp1.j3GcZR7WzX {
  background: #FFFD38;
}
.rqt1YAHlp1.ufX_lByEDh {
  background: #2D215C;
}
.rqt1YAHlp1.NESLQnr52d {
  background: #483C83;
}
.rqt1YAHlp1.wht_Fn8D2s {
  background: #58518d;
}
.rqt1YAHlp1.EmfFtty6JI {
  background: #7068A9;
}
.rqt1YAHlp1.OTiucADetV {
  background: #7f78b2;
}
.rqt1YAHlp1.R5luk1rZvR {
  background: #8f88bc;
}
.rqt1YAHlp1.f507jskMco {
  background: #000;
}
.rqt1YAHlp1.uYYUfv1PF3 {
  background: #282626;
}
.rqt1YAHlp1.CrkBhJXmq1 {
  background: #242222;
}
.rqt1YAHlp1.LWSHlygWns {
  background: #353838;
}
.rqt1YAHlp1.Hb_7zSnmOL {
  background: #666;
}
.rqt1YAHlp1.gps3wQMNmO {
  background: #999;
}
.N9HZjld418 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.N9HZjld418 .row0rdE6Be {
  display: none;
}
.cHWzixZTtC {
  position: relative;
  padding: 16px;
  border-bottom: 1px solid #e5e5e5;
}
.GWr2oLmcYq {
  display: flex;
  align-items: center;
}
.YY2TFByRBw {
  border-radius: 50%;
  height: 16px;
  width: 16px;
}
.nrE9Y_bbkQ,
.mstGU6IO3D {
  margin-left: 4px;
}
.nrE9Y_bbkQ {
  text-transform: uppercase;
}
.mstGU6IO3D {
  font-size: 10px;
  height: 14px;
  background-color: #f0f0f0;
  color: #212121;
}
.NhwmYRPeYg {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}
.pD2fBXKNWY {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pD2fBXKNWY .UMKoWd3W1R {
  margin-right: 32px;
}
.pD2fBXKNWY .UMKoWd3W1R:last-child {
  margin-right: 0;
}
.pD2fBXKNWY .UMKoWd3W1R .gZiJBt40_0 {
  font-size: 10px !important;
  font-weight: bold;
  text-transform: uppercase;
}
.pD2fBXKNWY .UMKoWd3W1R .UHxoshlnk7 {
  color: #030303;
}
.pD2fBXKNWY .LSCba3ZzZD input {
  text-align: center;
  border-radius: 3px;
}
.pD2fBXKNWY .LSCba3ZzZD input:checked {
  background-color: #00739a;
}
.pD2fBXKNWY .LSCba3ZzZD::before {
  font-size: 10px;
  vertical-align: middle;
}
.pD2fBXKNWY .cGMRA9d3L_ input:checked {
  background-color: #030303;
}
.oifBRXX_Uy {
  padding: 4px;
  position: absolute;
  cursor: pointer;
  font-size: 10px;
  right: 12px;
  top: 10px;
  color: #D93A40;
  visibility: hidden;
}
.cHWzixZTtC:hover {
  background-color: #FFF4D9;
}
.cHWzixZTtC:hover .oifBRXX_Uy {
  visibility: visible;
}
.cHWzixZTtC:hover .GPmGS7t8q3 {
  visibility: hidden;
}
.cHWzixZTtC .pulse-with-more__append-to {
  background: none;
}
.cHWzixZTtC .pulse-with-more__append-to div,
.cHWzixZTtC .pulse-with-more__append-to span {
  background: none !important;
}
.uOax9U3EsQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 10px;
}
.OgMaqk8Hxl {
  font-weight: 700;
  padding: 0 0 2px 4px;
}
.gUw_g3jM3x {
  display: flex;
  align-items: flex-end;
  text-align: end;
  cursor: pointer;
}
.GKSp2Gve5j {
  flex: 1;
  text-transform: uppercase;
  font-weight: bold;
}
.x1cb6KFrZm {
  margin-right: 4px;
}
.bpF2y56wX8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 10px;
}
.bpF2y56wX8 .fa-chevron-down {
  display: none !important;
}
.bpF2y56wX8 .pulse-select__ctn {
  width: 280px !important;
}
.XY8L77tLRP {
  display: flex;
}
.XY8L77tLRP .QR2fQPK9OW {
  font-size: 10px;
  font-weight: initial;
  letter-spacing: 0;
  min-width: 142px;
  margin-left: 8px;
  padding-left: 4px;
  border: 1px solid #e5e5e5;
}
.XY8L77tLRP .aC5NAU0lNc {
  margin-right: 4px;
}
.PAVMgI0Y4S {
  min-width: 280px;
}
.qLmlq1wBLY input {
  width: 250px !important;
}
._y6idYB2Z0 {
  display: flex;
  align-items: flex-end;
  text-align: end;
  cursor: pointer;
}
._y6idYB2Z0 .gD6CIyyjGH {
  flex: 1;
  text-transform: uppercase;
  font-weight: bold;
}
._y6idYB2Z0 .wLOzATWmKw {
  margin-right: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `OZDUUnd1xb`,
	"color-row": `cF0IRXE2mQ`,
	"color-tile": `rqt1YAHlp1`,
	"picker-component": `JPw2YILbBl`,
	"picker-element": `Va4VmIPyAD`,
	"active": `qTuaVhny4E`,
	"btn": `Xjh0AP_pvl`,
	"red-1": `CXgZub1GWF`,
	"red-2": `OKRcGhQvyv`,
	"red-3": `wARjpy_S_o`,
	"red-4": `f3F79NQbLN`,
	"red-5": `AOuJpArHxY`,
	"red-6": `sWB9hqH77f`,
	"orange-1": `Mf6010P8sD`,
	"orange-2": `xKHNHLhB98`,
	"orange-3": `q7I9W1C_uE`,
	"orange-4": `zTHhktdlXz`,
	"orange-5": `tA4GaxqD99`,
	"orange-6": `dmeWD56VN7`,
	"green-1": `KpS6oRWnTR`,
	"green-2": `Rx6tSrw5rL`,
	"green-3": `ZCx_1_lBFe`,
	"green-4": `Rwj4hinyra`,
	"green-5": `qxSLb6vjir`,
	"green-6": `xic2UGmpsT`,
	"blue-1": `JU2DAx58Pm`,
	"blue-2": `Fz5wdJcE1Y`,
	"blue-3": `uLpxLAwJeN`,
	"blue-4": `ILcd8mw3Hq`,
	"blue-5": `DGe1vEk_yl`,
	"blue-6": `xGpJpcCUB9`,
	"yellow-1": `vdCwVFaR2D`,
	"yellow-2": `FE4CfOnaIS`,
	"yellow-3": `BCVV32fIa6`,
	"yellow-4": `gXwbjJzDag`,
	"yellow-5": `rT0SBLFVZn`,
	"yellow-6": `j3GcZR7WzX`,
	"purple-1": `ufX_lByEDh`,
	"purple-2": `NESLQnr52d`,
	"purple-3": `wht_Fn8D2s`,
	"purple-4": `EmfFtty6JI`,
	"purple-5": `OTiucADetV`,
	"purple-6": `R5luk1rZvR`,
	"black-1": `f507jskMco`,
	"black-2": `uYYUfv1PF3`,
	"black-3": `CrkBhJXmq1`,
	"black-4": `LWSHlygWns`,
	"black-5": `Hb_7zSnmOL`,
	"black-6": `gps3wQMNmO`,
	"picker-theme": `N9HZjld418`,
	"arrow-regular": `row0rdE6Be`,
	"stage-reviews": `cHWzixZTtC`,
	"stage-reviews__user": `GWr2oLmcYq`,
	"stage-reviews__user--avatar": `YY2TFByRBw`,
	"stage-reviews__user--name": `nrE9Y_bbkQ`,
	"stage-reviews__user--role": `mstGU6IO3D`,
	"stage-reviews__permission": `NhwmYRPeYg`,
	"stage-reviews__permission--list": `pD2fBXKNWY`,
	"stage-reviews__permission--item": `UMKoWd3W1R`,
	"stage-reviews__permission--label": `gZiJBt40_0`,
	"stage-reviews__permission-label--disable": `UHxoshlnk7`,
	"permission__icon": `LSCba3ZzZD`,
	"permission__icon--disable": `cGMRA9d3L_`,
	"stage-reviews__removeIcon": `oifBRXX_Uy`,
	"stage-reviews__removeIcon--hide": `GPmGS7t8q3`,
	"stage-setting": `uOax9U3EsQ`,
	"stage-setting__label": `OgMaqk8Hxl`,
	"stage-setting__button": `gUw_g3jM3x`,
	"stage-setting__button--label": `GKSp2Gve5j`,
	"stage-setting__button--icon": `x1cb6KFrZm`,
	"add-users": `bpF2y56wX8`,
	"add-users__root": `XY8L77tLRP`,
	"add-users__btn": `QR2fQPK9OW`,
	"add-users__icon": `aC5NAU0lNc`,
	"add-users__root--input": `PAVMgI0Y4S`,
	"add-users__root--menu": `qLmlq1wBLY`,
	"add-users__stage-setting": `_y6idYB2Z0`,
	"add-users__stage-setting--label": `gD6CIyyjGH`,
	"add-users__stage-setting--icon": `wLOzATWmKw`
};
export default ___CSS_LOADER_EXPORT___;
